<template>
  <b-row>
    <b-col
      cols="12"
      xl="10"
      class="mb-3"
    >
      <b-card :title="$t('settings.subscription.title')">
        <p>
          {{ $t('settings.subscription.card-desc') }}
        </p>
        <div>
          <b-button
            type="outline-primary"
            @click="openPortalFn"
          >
            {{ $t('settings.subscription.manage') }}
          </b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>

export default {
  props: {
    openPortalFn: {
      type: Function,
      default: () => { },
    },
  },
}
</script>

<style scoped>

</style>
